import { useTranslation } from '@dukanti/shared';
import type { StockStatus } from '@dukanti/shared';
import { Badge } from '@/components/ui/badge';

export interface StockStatusBadgeProps {
  readonly status: StockStatus;
}

const STATUS_VARIANTS: Record<StockStatus, 'success' | 'warning' | 'destructive'> = {
  healthy: 'success',
  low_stock: 'warning',
  out_of_stock: 'destructive',
};

export function StockStatusBadge({ status }: StockStatusBadgeProps): React.JSX.Element {
  const { t } = useTranslation();

  const labelKey =
    status === 'healthy'
      ? 'admin.stock.status.healthy'
      : status === 'low_stock'
        ? 'admin.stock.status.lowStock'
        : 'admin.stock.status.outOfStock';

  const label = t(labelKey);

  return (
    <Badge
      data-testid={`stock-status-badge-${status}`}
      aria-label={label}
      variant={STATUS_VARIANTS[status]}
      className="rounded-md px-2 py-0.5 text-[11px] uppercase tracking-wide"
    >
      {label}
    </Badge>
  );
}
